'use client';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import { Img } from '@/src/components/common/ui/images/Img.jsx';
import Title from '@/src/components/common/ui/text/Title.jsx';
import { StyledTeam } from '@/src/components/common/eco/sections/people/people.style.js';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';

const BrandList = ({ data }) => {


	const isMobile = useDeviceTypeMobile();

	// Memoize posts list to avoid re-render issues
	const posts = useMemo(() => data?.posts?.list || [], [data?.posts?.list]);

	// Memoize the renderBrandItem function to prevent unnecessary re-renders
	const renderBrandItem = useMemo(() =>
			(e, index) => {
				const thumb = e?.images?.find((f) => f?.thumb === 'on');

				return (
					<Col md={3} className="brand-item-left fade-up" key={index}>
						<div className="image-wrapper">
							<div className="content">
								<p className="decription">{reactHtmlParser(e?.data?.description)}</p>
							</div>
							<Img src={e?.images?.[0]?.full_path} layout={'fill'} alt={e?.data?.title || 'Member Image'} />
							<div className="info">
								<p>{reactHtmlParser(e?.data?.subtitle)}</p>
								<p>{reactHtmlParser(e?.data?.short_desc)}</p>
							</div>

						</div>

					</Col>
				);
			},
		[],
	);


	const renderBrandItemMobile = useMemo(() =>
			(e, index) => {
				const thumb = e?.images?.find((f) => f?.thumb === 'on');

				return (
					<Col md={3} className="brand-item-left fade-up" key={index}>
						<div className="image-wrapper">
							<Img src={e?.images?.[0]?.full_path} layout={'fill'} alt={e?.data?.title || 'Member Image'} />
						</div>

						<div className="info mobile-info">
							<p>{reactHtmlParser(e?.data?.subtitle)}</p>
							<p>{reactHtmlParser(e?.data?.short_desc)}</p>
						</div>
					</Col>
				);
			},
		[],
	);



	return (
		<StyledTeam className="brandlist" id={'team'} >
			<Container>
				<Row>
				<Col md={12}>
					{
						data?.section_data?.subtitle &&
						<Title
							tag={'h2'}
							margin={'0 0 60px'}
							text={data?.section_data?.subtitle}
							color={'#fff'}
						/>
					}
					</Col>
					{data?.posts?.list.length > 0 && !isMobile && data?.posts?.list.map((e, index) => renderBrandItem(e, index))}
					{data?.posts?.list.length > 0 && isMobile && data?.posts?.list.map((e, index) => renderBrandItemMobile(e, index))}
				</Row>
			</Container>


		</StyledTeam>
	);
};



export default React.memo(BrandList);